export const paymentStatementsConfig = {
  itemBlocks: [
    {
      name: "labremittanceadvice",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Remittance Advice",
        icon: "fa-file-pdf-o",
      },
      formFields: [
        {
          name: "labremittanceadvice",
          label: "Remittance Advice",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "labremittanceadvice",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
    {
      name: "salestaxregister",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Tax Register",
        icon: "fa-file-pdf-o",
      },
      formFields: [
        {
          name: "salestaxregister",
          label: "Tax Register",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "salestaxregister",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
    {
      name: "noticeofdirectdeposit",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Notice of Direct Deposit",
        icon: "fa-file-pdf-o",
      },
      formFields: [
        {
          name: "noticeofdirectdeposit",
          label: "Notice of Direct Deposit",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "noticeofdirectdeposit",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
    {
      name: "salestaxsummary",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Tax Summary",
        icon: "fa-file-pdf-o",
      },
      formFields: [
        {
          name: "salestaxsummary",
          label: "Tax Summary",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "salestaxsummary",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
    {
      name: "downloadablepaymentfile",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Downloadable Payment File",
        icon: "",
      },
      formFields: [
        {
          name: "downloadablepaymentfile",
          label: "Payment File",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "downloadablepaymentfile",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
    {
      name: "outstandingmaterialsinvoicereport",
      style: {
        class: "col-md-6",
      },
      header: {
        title: "Outstanding Materials Invoice Report",
        icon: "fa-file-pdf-o",
      },
      formFields: [
        {
          name: "outstandingmaterialsinvoicereport",
          label: "Outstanding Materials Invoice Report",
          type: "dropdown",
        },
      ],
      buttons: [
        {
          name: "outstandingmaterialsinvoicereport",
          label: "View",
          icon: "",
          action: "",
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/data/paymentStatments.config.ts